import { GET_PHONE } from '../Type';

export const getPhoneNumber = (data) => {
  return {
    type: GET_PHONE,
    data: data
  }
}